import React, { useState } from "react";
import EnquiryForm from "../modal/FormBox";
import { ChevronDown, ChevronUp } from "lucide-react"; // Import the Lucide icons

const Overview = ({ OverviewData }) => {
  const [showForm, setShowForm] = useState(false);
  const [readMore, setReadMore] = useState(false);

  const handleOpenForm = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };
  const handleToggle = () => {
    setReadMore(!readMore);
  };

  const {
    overviewImage,
    tagline,
    description,
    caption,
    amenities,
    buttonmessage,
    buttonLabel,
  } = OverviewData;

  return (
    <>
      <section className=" mb-20">
        <div className="about-one__img-two"></div>
        <div className="container">
          <div className="row">
            <div className="col-xl-6">
              <div className="about-one__left">
                <div
                  className="about-one__img-box wow slideInLeft"
                  data-wow-delay="100ms"
                  data-wow-duration="2500ms"
                >
                  <div className="about-one__img">
                    <img src={overviewImage} alt="description" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="about-one__right">
                <div className="section-title text-left">
                  <h3 className="section-title__title mt-10">{tagline}</h3>
                  <p className=" text-gray-800">{caption}</p>
                </div>
                <div
                  className={`transition-all duration-300 ${
                    readMore ? "h-48 overflow-y-auto" : "h-48 overflow-hidden"
                  }`}
                  style={{
                    WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS devices
                  }}
                >
                  {description.map((text, index) => (
                    <p
                      key={index}
                      className="about-three__text text-[14px] mb-2"
                    >
                      {text}
                    </p>
                  ))}
                </div>
                <br />
                {buttonLabel && (
                  <div className="cta-two__btn-box">
                    <button
                      className=" bg-[--alipes-base] flex items-center gap-2 w-[200px] py-2 px-10  text-white text-lg"
                      onClick={handleToggle}
                    >
                      {readMore ? (
                        <>
                          Read Less <ChevronUp className="w-4 h-4" />
                        </>
                      ) : (
                        <>
                          Read More <ChevronDown className="w-4 h-4" />
                        </>
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {showForm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-6 shadow-lg relative w-full max-w-lg">
            <button
              onClick={handleCloseForm}
              className="absolute top-2 right-2 text-black bg-gray-200 rounded-full p-2 hover:bg-gray-300"
            >
              ✕
            </button>
            <EnquiryForm />
          </div>
        </div>
      )}
    </>
  );
};

export default Overview;
